import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { Close, Radio, MusicNote, Public, Headphones, PlayArrow, Favorite, Language } from '@mui/icons-material';
import '../styles/GettingStartedModal.css';

const GettingStartedModal = ({ onClose }) => {
  const { getText } = useLanguage();
  const { darkMode } = useTheme();

  return (
    <div className="modal-overlay">
      <div className={`getting-started-modal ${darkMode ? 'dark-mode' : ''}`}>
        <button className="close-button" onClick={onClose}>
          <Close />
        </button>
        
        <div className="modal-content">
          <div className="modal-header">
            <h2>{getText('gettingStartedTitle')}</h2>
            <p className="modal-description">{getText('gettingStartedDesc')}</p>
          </div>

          <div className="modal-features">
            <div className="feature-item">
              <div className="feature-icon">
                <Radio />
              </div>
              <div className="feature-text">
                <h3>{getText('exploreStations')}</h3>
                <p>{getText('featuredStations')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <MusicNote />
              </div>
              <div className="feature-text">
                <h3>{getText('browseByGenre')}</h3>
                <p>{getText('stationsInGenre').replace('{genre}', getText('various'))}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Public />
              </div>
              <div className="feature-text">
                <h3>{getText('findLocalStations')}</h3>
                <p>{getText('nearbyStations')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Headphones />
              </div>
              <div className="feature-text">
                <h3>{getText('createAccount')}</h3>
                <p>{getText('userAccountDesc')}</p>
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <button className="start-button" onClick={onClose}>
              <PlayArrow />
              <span>Start Exploring</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStartedModal; 